<div class="ai-wrapper" [class.fullscreen]="fullscreen">
  <button
    class="btn btn-close-fs-modal"
    *ngIf="fullscreen"
    title="Close"
    aria-label="close"
    (click)="toggleFullscreen()">
    <i class="bi bi-x-lg"></i>
  </button>
  <div class="card border-0" [class.fullscreen]="fullscreen">
    <div class="ai-header">
      <div class="ai-header-logo">
        <img
          src="/assets/icon-ai-assistant.svg"
          class="ai-icon"
          alt="AI Assistant" />
        <div>
          <h1>Smart Assistant</h1>
          <div class="preview">AI Beta Preview</div>
        </div>
      </div>
      <div class="ai-header-btns" @fadeInOut>
        <button
          *ngIf="currentConversation"
          class="btn btn-text"
          (click)="resetConversation()">
          <i class="bi bi-plus me-1"></i>New Chat
        </button>
        <!-- THIS FEATURE TO BE DEVELOPED SOON -->
        <!-- <button class="btn btn-text" (click)="previousChatsModal.open()">
          <i class="bi bi-search me-1"></i>Search
        </button> -->
        <button
          aria-label="Fullscreen"
          class="btn btn-reset d-none d-xl-block"
          *ngIf="!fullscreen"
          (click)="toggleFullscreen()">
          <i class="bi bi-fullscreen fs-16"></i>
        </button>
      </div>
    </div>
    <div class="message-area" #messagesArea>
      <div class="grad-border"></div>
      <div
        class="tip-overlay"
        *ngIf="messages && messages.length === 0"
        @delayfadeInOut>
        💡 <strong>Tip</strong>: Attach images or documents, ask follow-up
        questions, or switch modes anytime
      </div>
      <div class="p-4">
        <ng-container *ngFor="let message of messages">
          <ng-container *ngIf="message.role === 'user'">
            <div class="message-wrapper d-flex justify-content-end">
              <div class="message user-message">
                <div class="message-content">
                  <markdown>{{ message.content }}</markdown>
                </div>
                <ng-container *ngFor="let file of message.files">
                  <div class="file-attachment">
                    {{ file.name }}
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="message.role === 'assistant'">
            <div class="message-wrapper">
              <div class="d-flex justify-content-start align-items-center">
                <div>
                  <img
                    src="/assets/icon-ai-assistant-sm.svg"
                    class="ai-icon me-4"
                    alt="AI Assistant" />
                </div>
                <div class="message ai-message">
                  <div *ngIf="message.thinking" class="thinking-content">
                    {{ message.thinking }}
                  </div>
                  <div class="message-content">
                    <markdown>{{ message.content }}</markdown>
                  </div>
                  <div *ngIf="message.isComplete" class="action-btns">
                    <button class="btn-reset px-2" ngbTooltip="Copy">
                      <i
                        class="bi bi-copy"
                        (click)="copyMessage(message.content, $event)"></i>
                    </button>
                    <button
                      class="btn-reset px-2"
                      ngbTooltip="Good Response"
                      (click)="
                        submitUserFeedback(message, AIUserFeedback.THUMBS_UP)
                      ">
                      <i
                        class="bi"
                        [ngClass]="
                          isThumbsUpSelected(message)
                            ? 'bi-hand-thumbs-up-fill'
                            : 'bi-hand-thumbs-up'
                        "></i>
                    </button>
                    <button
                      class="btn-reset px-2"
                      ngbTooltip="Bad Response"
                      (click)="
                        submitUserFeedback(message, AIUserFeedback.THUMBS_DOWN)
                      ">
                      <i
                        class="bi"
                        [ngClass]="
                          isThumbsDownSelected(message)
                            ? 'bi-hand-thumbs-down-fill'
                            : 'bi-hand-thumbs-down'
                        "></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="glai-prompt-wrapper" @fadeInOut>
      <div class="row-prompt">
        <div class="mode-select" ngbDropdown #myDrop="ngbDropdown">
          <button
            type="button"
            aria-label="AI Mode"
            class="btn-reset btn-mode me-2 fs-20"
            id="dropdownManual"
            ngbDropdownAnchor
            (focus)="myDrop.open()">
            <i
              class="bi"
              [ngbTooltip]="selectedPath"
              [autoClose]="true"
              [ngClass]="currentClass"></i>
          </button>
          <div
            ngbDropdownMenu
            aria-labelledby="dropdownManual"
            class="dropdown-menu">
            <div class="fs-13 fw-700 label">AI MODE</div>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('default')"
              (click)="toggleMode('default')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('default') ? 'bi-chat-fill' : 'bi-chat'
                "></i
              >Question & Answer
            </button>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('lesson_planning')"
              (click)="toggleMode('lesson_planning')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('lesson_planning')
                    ? 'bi-book'
                    : 'bi-book'
                "></i
              >Lesson & Activity Planning
            </button>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('diff_and_mods')"
              (click)="toggleMode('diff_and_mods')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('diff_and_mods')
                    ? 'bi-people-fill'
                    : 'bi-people'
                "></i
              >Differentiation and Modifications
            </button>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('assessments_and_feedback')"
              (click)="toggleMode('assessments_and_feedback')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('assessments_and_feedback')
                    ? 'bi-clipboard-check-fill'
                    : 'bi-clipboard-check'
                "></i
              >Assessments and Feedback
            </button>
            <button
              ngbDropdownItem
              class="btn btn-ai-select"
              [class.active]="activeModes.includes('communication')"
              (click)="toggleMode('communication')">
              <i
                class="bi"
                [ngClass]="
                  activeModes.includes('communication')
                    ? 'bi-envelope-fill'
                    : 'bi-envelope'
                "></i
              >Professional Communication
            </button>
          </div>
        </div>
        <div class="input-file">
          @if(uploadedFiles.length < 1) {
          <app-file-upload
            #uploadComponent
            [ngbTooltip]="'Attach File'"
            [uploadType]="uploadType"
            [style]="uploadStyle"
            (outputFiles)="addToFileList($event); fileUploads.emit($event)" />
          } @else {
          <div
            class="btn btn-reset btn-file-modal"
            (click)="fileMgmtModal.open()">
            <ng-container *ngIf="uploadedFiles">
              <div class="total-files" *ngIf="uploadedFiles.length > 0">
                {{ uploadedFiles.length }}
              </div>
            </ng-container>
            <i class="bi bi-paperclip"></i>
          </div>
          }
        </div>
        <textarea
          #textareaprompt
          class="areaprompt"
          rows="1"
          [disabled]="isLoading"
          placeholder="Ask me anything..."
          [(ngModel)]="userMessage"
          (keyup.enter)="sendMessage()"></textarea>
        <button
          aria-label="Send Message"
          class="btn btn-primary input-btn"
          (click)="sendMessage()"
          [disabled]="isLoading || !userMessage.trim()">
          <i *ngIf="!isLoading" class="bi bi-send"></i>
          <i *ngIf="isLoading" class="bi bi-hourglass-split"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal
  #fileMgmtModal
  [modalConfig]="{
    titleText: 'Attachments',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    options: { size: 'md' }
  }">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="fileMgmtModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="my-3 fs-14">
          <ng-container *ngIf="uploadedFiles">
            <div
              *ngIf="uploadedFiles.length > 0"
              class="modal-file-list-wrapper">
              <app-file-list
                (deletedFile)="
                  removeFromFileList($event); fileMgmtModal.close()
                "
                [fileList]="uploadedFiles"></app-file-list>
            </div>
          </ng-container>
          <app-file-upload
            #uploadComponent
            [ngbTooltip]="'Attach File'"
            [uploadType]="uploadType"
            [style]="modalUploadStyle"
            (outputFiles)="addToFileList($event); fileUploads.emit($event)" />
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-end" footerContent>
    <button (click)="fileMgmtModal.close()" class="btn btn-reset">Done</button>
  </div>
</app-modal>

<app-modal
  #previousChatsModal
  [modalConfig]="{
    titleText: 'Previous Chats',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    options: { size: 'lg' }
  }">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="previousChatsModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="container">
    <div class="row">
      <div class="col-12 d-flex justify-content-center align-items-center">
        <div class="my-3 fs-14">PREVIOUS CHAT MODAL CONTENT</div>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-between" footerContent>
    <button (click)="previousChatsModal.close()" class="btn btn-reset">
      Close
    </button>
  </div>
</app-modal>
